import React from 'react';
import PropTypes from 'prop-types';
// styles
import cx from 'classnames';
import styled from 'styled-components';
// logic
import { useTranslation } from 'react-i18next';
// components
import { LoadTypeLoadIcon, LoadTypeUnloadIcon } from 'refactored/ui/icons';

export const getContainerData = (stops) => {
  const stopLoads = [];
  Array.isArray(stops) &&
    stops.forEach((s) => {
      stopLoads.push(...s.load_dropoff);
      stopLoads.push(...s.load_pickup);
    });

  const containers = stopLoads.filter(
    (load) => load.load_type === 'SHIPPING_CONTAINER'
  );
  const nonContainers = stopLoads.filter(
    (load) => load.load_type !== 'SHIPPING_CONTAINER'
  );
  const numberOfContainers =
    containers.reduce(
      (accumulator, currentValue) => accumulator + currentValue.number_of_items,
      0
    ) / 2;
  const containersWeight =
    containers.reduce(
      (accumulator, currentValue) => accumulator + currentValue.total_weight,
      0
    ) / 2;
  const nonContainersWeight =
    nonContainers.reduce(
      (accumulator, currentValue) => accumulator + currentValue.total_weight,
      0
    ) / 2;

  const stopTypes = Array.isArray(stops) ? stops.map((s) => s.stop_type) : [];
  const numberOfPickups = stopTypes.filter(
    (stop_type) => stop_type === 'PICKUP'
  ).length;
  const numberOfDropoffs = stopTypes.filter(
    (stop_type) => stop_type === 'DROPOFF'
  ).length;

  const isExport = numberOfPickups > numberOfDropoffs;

  const reference_number =
    stopLoads.find((load) => load.reference_number !== undefined)
      ?.reference_number || null;
  const container_iso_code =
    stopLoads.find((load) => load.container_iso_code !== undefined)
      ?.container_iso_code || null;

  const containerData = {
    numberOfContainers,
    containersWeight,
    nonContainersWeight,
    reference_number,
    container_iso_code,
    isExport,
  };
  return containerData;
};

const LoadsSummaryTableTenant = ({ className, stopIndex, stops }) => {
  const { t } = useTranslation('loads');

  const stopType = stopIndex === 0 ? 'pickup' : 'dropoff';
  const stopTypeLabel = t(`${stopType}_of`);

  const containerData = getContainerData(stops);
  const intermediateStop = stopIndex > 0 && stopIndex < stops.length - 1;

  const showTotalWeight =
    (containerData.isExport && stopIndex === stops.length - 1) ||
    (!containerData.isExport && stopIndex === 0);

  const stopNonContainerLoads = [
    ...stops[stopIndex].load_pickup,
    ...stops[stopIndex].load_dropoff,
  ];

  const stopNonContainerWeight = stopNonContainerLoads[0].total_weight;

  return (
    <div className={cx(className, 'load-info')}>
      <div className="load-header">
        {stopType === 'pickup' && <LoadTypeLoadIcon />}
        {stopType === 'dropoff' && <LoadTypeUnloadIcon />}
        {stopTypeLabel}
      </div>
      <div className="loads-table">
        <table>
          <tbody>
            {!intermediateStop ? (
              <>
                <tr>
                  <td>
                    {containerData.numberOfContainers} contenedor{' '}
                    {containerData.container_iso_code}
                  </td>
                  <td>{containerData.reference_number}</td>
                </tr>
                <tr>
                  <td>Tara: </td>
                  <td>{containerData.containersWeight} kg</td>
                </tr>
                <tr>
                  <td>Peso de la carga: </td>
                  <td>
                    {showTotalWeight ? containerData.nonContainersWeight : 0} kg
                  </td>
                </tr>
              </>
            ) : (
              <tr>
                <td>Peso de la carga: </td>
                <td>{stopNonContainerWeight} kg</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

LoadsSummaryTableTenant.propTypes = {
  className: PropTypes.string,
  loads: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default styled(LoadsSummaryTableTenant)`
  &.load-info {
    line-height: 24px;
    font-size: 16px;
    color: var(--grey700);
    .load-header {
      margin-bottom: 7px;
      display: flex;
      align-items: center;
      svg {
        margin-right: 8px;
      }
    }
    .loads-table {
      padding-left: 28px;
      padding-right: 3px;
      table {
        width: 100%;
        border-collapse: collapse;
        tr {
          td {
            /* border-top: 1px solid var(--grey300); */
          }
          td:first-child {
          }
        }
        tr:first-child {
          td {
            border: none;
          }
        }
        td {
          width: 25%;
          text-align: right;
          padding: 5px;
        }
        td:first-child {
          width: 50%;
          text-align: left;
        }
      }
    }
  }
`;
